export interface Partner {
  key: string;
  name: string;
  alias: string;
  monogram: string;
  logo: string;
  tagline: string;
  overview: string;
  capabilities: string[];
  role: string;
  website: string;
}

export const partners: Partner[] = [
  {
    key: "djt",
    name: "DJT",
    alias: "DJT Haika / DJT EV Powertech",
    monogram: "DJT",
    logo: "https://public.readdy.ai/ai/img_res/975a2203-c902-4a82-87f9-957d801b54a3.png",
    tagline: "Charging infrastructure & EV mobility technology",
    overview:
      "DJT works across EV charging infrastructure and the wider EV mobility technology space. Its public focus covers electric vehicle charging and smart charging ecosystems that support day-to-day electric mobility operations.",
    capabilities: [
      "EV charging infrastructure",
      "Smart charging ecosystem",
      "EV mobility technology",
    ],
    role: "Contributes charging infrastructure and charging ecosystem technology to the collaboration.",
    website: "https://djthaika.com/",
  },
  {
    key: "zero21",
    name: "ZERO21",
    alias: "ZERO21 Autos / ZERO21 Retrosolutions",
    monogram: "021",
    logo: "https://static.readdy.ai/image/b8a021112837a070edfa44e380da93b7/eb878807b07a22557fe6b83f786b74a4.png",
    tagline: "EV innovation & retrofit solutions",
    overview:
      "ZERO21 operates in the EV innovation space with work spanning electric three-wheeler solutions and retrofit/conversion experience. Its public material positions it around practical electric mobility and conversion.",
    capabilities: [
      "EV innovation",
      "Electric three-wheeler solutions",
      "Retrofit and conversion experience",
    ],
    role: "Contributes EV product thinking and retrofit/conversion experience to the collaboration.",
    website: "https://zero21.autos/",
  },
  {
    key: "kallords",
    name: "KAL LORD'S",
    alias: "KAL Lord's Technologies",
    monogram: "KLT",
    logo: "https://static.readdy.ai/image/b8a021112837a070edfa44e380da93b7/c505bddbdf3adb4abfdd2ce8878701d2.png",
    tagline: "EV engineering & manufacturing ecosystem",
    overview:
      "KAL Lord's Technologies works across electric mobility products and EV engineering. Its public capabilities include a manufacturing ecosystem and vehicle technology capabilities that support electric vehicle development.",
    capabilities: [
      "Electric mobility products",
      "EV engineering",
      "Manufacturing ecosystem",
      "Vehicle technology capabilities",
    ],
    role: "Contributes EV engineering, manufacturing ecosystem and vehicle technology capabilities.",
    website: "https://kallordstech.com/",
  },
];